import type { CSSProperties, ReactElement, ReactNode, RefObject } from 'react';
import { motion } from 'framer-motion';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CscrollableRootProps {
    children: ReactNode;
    className: string;
    dataElScope: DataElScope;
    enableLayoutScroll: boolean;
    scrollRef: RefObject<HTMLDivElement | null>;
    style: CSSProperties;
}
export function CscrollableRoot({ children, className, dataElScope, enableLayoutScroll, scrollRef, style, }: CscrollableRootProps): ReactElement {
    if (enableLayoutScroll) {
        return (
        <motion.div data-el={dataEl(dataElScope, 'Viewport')} ref={scrollRef} layoutScroll className={className} style={style}>
        {children}
      </motion.div>
      );
    }
    return (
    <div data-el={dataEl(dataElScope, 'Viewport')} ref={scrollRef} className={className} style={style}>
      {children}
    </div>
    );
}
